var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7090_30603)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5579 5.53277C12.6874 4.69741 11.3128 4.69741 10.4423 5.53277L5.8158 9.97211C5.70245 10.0808 5.6262 10.2225 5.59786 10.377C5.04373 13.3989 5.00283 16.4925 5.47687 19.528L5.58939 20.2485H8.56585V14.0372C8.56585 13.6229 8.90164 13.2872 9.31585 13.2872H14.6843C15.0985 13.2872 15.4343 13.6229 15.4343 14.0372V20.2485H18.4108L18.5233 19.528C18.9973 16.4925 18.9564 13.3989 18.4023 10.377C18.374 10.2225 18.2977 10.0808 18.1844 9.97211L13.5579 5.53277ZM9.40369 4.45044C10.8547 3.05818 13.1455 3.05818 14.5965 4.45044L19.2229 8.88978C19.5635 9.21657 19.7926 9.64226 19.8777 10.1065C20.4622 13.2941 20.5054 16.5575 20.0053 19.7594L19.8246 20.9169C19.7498 21.3956 19.3375 21.7485 18.853 21.7485H14.6843C14.2701 21.7485 13.9343 21.4127 13.9343 20.9985V14.7872H10.0659V20.9985C10.0659 21.4127 9.73006 21.7485 9.31585 21.7485H5.14712C4.66264 21.7485 4.25035 21.3956 4.1756 20.9169L3.99484 19.7594C3.49479 16.5575 3.53794 13.2941 4.12247 10.1065C4.2076 9.64226 4.43668 9.21657 4.77725 8.88978L9.40369 4.45044Z",
    fill: "#2B323B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7090_30603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.09de01e89aeed8d35716bd62f7edcd1c.svg";
export { ForwardRef as ReactComponent };